import { render, staticRenderFns } from "./DelArtTip.vue?vue&type=template&id=b838b304&scoped=true"
import script from "./DelArtTip.vue?vue&type=script&lang=js"
export * from "./DelArtTip.vue?vue&type=script&lang=js"
import style0 from "./DelArtTip.vue?vue&type=style&index=0&id=b838b304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b838b304",
  null
  
)

export default component.exports